<template>
    <outlined-card
            :showDivider="false"
            :hover="true"
            :href="notesLink()"
            class="card-hover-border">

        <template v-slot:title>
            <v-icon class="primary--text mr-1">
                mdi-bookmark-multiple-outline
            </v-icon>
            <h2 class="text-body-1 font-weight-medium">Notes and Bookmarks</h2>
        </template>

        <template v-slot:content>
            <loading-block :is-loading="loadingCounts">
                <div class="w-full">
                    <template v-if="countAll">
                        <div class="text-h6 font-weight-medium mb-2">{{ getNotesCountMessage() }}</div>
                        <div class="text-body-2 text--secondary">Last 30 days</div>
                    </template>
                    <template v-else>
                        <div class="text-h6 font-weight-medium mb-2">No notes yet</div>
                        <div class="text-body-2 text--secondary">Add notes to get started</div>
                    </template>

                </div>
            </loading-block>
        </template>
    </outlined-card>
</template>

<script>
import OutlinedCard from "../../../components/cards/OutlinedCard.vue";
import {ApiService} from "../../../api/ApiService";
import {ErrorHandler} from "../../../classes/ErrorHandler";
import LoadingBlock from "../../../components/LoadingBlock.vue";

export default {
    components: {LoadingBlock, OutlinedCard},
    data() {
        return {
            loadingCounts: false,
            countLastMonth: 0,
            countAll: 0,
        }
    },
    methods: {
        notesLink() {
            return Routing.generate('notes');
        },
        getNotesCountMessage() {
            return `${this.countLastMonth} note${this.countLastMonth === 1 ? '' : 's'} added`;
        }
    },
    mounted() {

        this.loadingCounts = true;

        ApiService.getNoteCounts().then((data) => {

            const annotationCount30 = (data?.annotation_counts?.last_30_days || 0);
            const bookmarkCount30 = (data?.bookmark_counts?.last_30_days || 0);
            this.countLastMonth = annotationCount30 + bookmarkCount30;

            const annotationCountAll = (data?.annotation_counts?.all_time || 0);
            const bookmarkCountAll = (data?.bookmark_counts?.all_time || 0);
            this.countAll = annotationCountAll + bookmarkCountAll;

        }).catch(ErrorHandler.handle).finally(() => {
            this.loadingCounts = false;
        });
    }
}
</script>

<style lang="scss" scoped>
.card-hover-border:hover {
    color: rgba(0,0,0,.87) !important;
    border: 1px solid black;
    box-shadow: none;
}
</style>